import { randomFromArray } from "./helpers/random-from-array.js";
import makeId from "./helpers/make-id.js";

const skinAndNameCombos = [
  { skinId: "skin_f1", name: "Mary" },
  { skinId: "skin_f1", name: "Georgia" },
  { skinId: "skin_f1", name: "Heather" },
  { skinId: "skin_f1", name: "Lynn" },
  { skinId: "skin_f1", name: "Sarah" },

  { skinId: "skin_f2", name: "Betty Sue" },
  { skinId: "skin_f2", name: "Samantha" },
  { skinId: "skin_f2", name: "Barb" },
  { skinId: "skin_f2", name: "Susanna" },
  { skinId: "skin_f2", name: "Natalia" },

  { skinId: "skin_f3", name: "Rebecca" },
  { skinId: "skin_f3", name: "Ronna" },
  { skinId: "skin_f3", name: "Sabella" },
  { skinId: "skin_f3", name: "Daniella" },
  { skinId: "skin_f3", name: "Evette" },

  { skinId: "skin_m1", name: "Oliver" },
  { skinId: "skin_m1", name: "Sid" },
  { skinId: "skin_m1", name: "Jed" },
  { skinId: "skin_m1", name: "Tommy" },
  { skinId: "skin_m1", name: "Sebastian" },

  { skinId: "skin_m2", name: "Jerry" },
  { skinId: "skin_m2", name: "Alex" },
  { skinId: "skin_m2", name: "Sai" },
  { skinId: "skin_m2", name: "Reyansh" },
  { skinId: "skin_m2", name: "Parth" },

  { skinId: "skin_m3", name: "Harold" },
  { skinId: "skin_m3", name: "Biff" },
  { skinId: "skin_m3", name: "Don" },
  { skinId: "skin_m3", name: "Jeremiah" },
  { skinId: "skin_m3", name: "Barry" },

  { skinId: "skin_m4", name: "Bengi" },
  { skinId: "skin_m4", name: "Daniel" },
  { skinId: "skin_m4", name: "Nick" },
  { skinId: "skin_m4", name: "Frank" },
  { skinId: "skin_m4", name: "Dominic" },

  { skinId: "skin_bonus1", name: "Sunny" },
  { skinId: "skin_bonus1", name: "Big D" },

  { skinId: "skin_bonus2", name: "Nicky" },
  { skinId: "skin_bonus2", name: "Joey" },
];

export const sampleLoadouts = [
  {
    name: "DPS A",
    loadoutId: "dpsA",
    loadoutTitle: "Hackalete",
    class: "dps",
    level: 5,
    attacks: [
      { actionId: "special_promise" },
      { actionId: "special_foreach" },
      { actionId: "special_curl" },
      { actionId: "special_headphones" },
      { actionId: "special_team-slice" } //super
    ],
    items: [
      {
        actionId: "item_danger-boost",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_honeypot-trap",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 5,
        recovering: 2,
        cursing: 0,
        cleaning: 0,
        boosting: 1,
        thief: 1
      }
    }
  },

  {
    name: "DPS B",
    loadoutId: "dpsB",
    loadoutTitle: "Artisian",
    class: "dps",
    level: 5,
    attacks: [
      { actionId: "special_slice" },
      { actionId: "special_screen-crack" },
      { actionId: "special_troll" },
      { actionId: "special_clean" },
      { actionId: "special_team-foreach" } //super
    ],
    items: [
      {
        actionId: "item_attack-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_breakpoint",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 5,
        recovering: 2,
        cursing: 0,
        cleaning: 0,
        boosting: 3,
        thief: 0
      }
    }
  },

  {
    name: "DPS C",
    loadoutId: "dpsC",
    loadoutTitle: "Bitslinger",
    class: "dps",
    level: 5,
    attacks: [
      { actionId: "special_slice" },
      { actionId: "special_sql-injection" },
      { actionId: "special_deadline" },
      { actionId: "special_troll" },
      { actionId: "special_team-foreach" } //super
    ],
    items: [
      {
        actionId: "item_attack-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_attack-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_speed-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 6,
        recovering: 0,
        cursing: 0,
        cleaning: 0,
        boosting: 3,
        thief: 0
      }
    }
  },

  {
    name: "DISRUPT A",
    loadoutId: "disruptA",
    loadoutTitle: "Quality Assurance",
    class: "disrupt",
    level: 5,
    attacks: [
      //{actionId: "special_foreach"},
      { actionId: "special_bug" },
      { actionId: "special_garbage-jammer" },
      { actionId: "special_headphones" },
      { actionId: "special_wildfire" } //super
    ],
    items: [
      {
        actionId: "item_network-reset-code",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_defense-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 1,
        recovering: 2,
        cursing: 5,
        cleaning: 2,
        boosting: 3,
        thief: 1
      }
    }
  },
  {
    name: "DISRUPT B",
    loadoutId: "disruptB",
    loadoutTitle: "Operator",
    class: "disrupt",
    level: 5,
    attacks: [
      { actionId: "special_ddos" },
      { actionId: "special_copy-paste" },
      { actionId: "special_troll" },
      { actionId: "special_thrash" },
      { actionId: "special_commit" }, //super
      { actionId: "special_revert" } //super
    ],
    items: [
      {
        actionId: "item_honeypot-trap",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_defense-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 1,
        recovering: 2,
        cursing: 5,
        cleaning: 2,
        boosting: 3,
        thief: 3
      }
    }
  },

  {
    name: "DISRUPT C",
    loadoutId: "disruptC",
    loadoutTitle: "Infiltrator",
    class: "disrupt",
    level: 5,
    attacks: [
      { actionId: "special_ddos" },
      { actionId: "special_copy-paste" },
      { actionId: "special_scope-bomb" },
      { actionId: "special_firewall" },
      { actionId: "special_sql-drop" } //super
    ],
    items: [
      {
        actionId: "item_max-danger-boost",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 1,
        recovering: 2,
        cursing: 5,
        cleaning: 2,
        boosting: 3,
        thief: 3
      }
    }
  },

  {
    name: "SUPPORT A",
    loadoutId: "supportA",
    loadoutTitle: "Scrum Master",
    class: "support",
    level: 5,
    attacks: [
      { actionId: "special_scrum" },
      { actionId: "special_deadline" },
      { actionId: "special_headphones" },
      { actionId: "special_scope-bomb" },
      { actionId: "special_team-clean" } //super
    ],
    items: [
      {
        actionId: "item_mini-battery-pack",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_defense-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_revive",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 2,
        recovering: 6,
        cursing: 3,
        cleaning: 2,
        boosting: 6,
        thief: 2
      }
    }
  },
  {
    name: "SUPPORT B",
    loadoutId: "supportB",
    loadoutTitle: "Security Engineer",
    class: "support",
    level: 5,
    attacks: [
      { actionId: "special_slice" },
      { actionId: "special_firewall" },
      { actionId: "special_curl-mk2" },
      { actionId: "special_clean" },
      { actionId: "special_team-revive" } //super
    ],
    items: [
      {
        actionId: "item_mini-battery-pack",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_team-danger-boost",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_speed-sticker-i",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 2,
        recovering: 6,
        cursing: 3,
        cleaning: 2,
        boosting: 6,
        thief: 2
      }
    }
  },
  {
    name: "SUPPORT C",
    loadoutId: "supportC",
    loadoutTitle: "Help Desk",
    class: "support",
    level: 5,
    attacks: [
      { actionId: "special_scrum" },
      { actionId: "special_firewall" },
      { actionId: "special_sql-injection" },
      { actionId: "special_clean" },
      { actionId: "special_team-revive" } //super
    ],
    items: [
      {
        actionId: "item_mini-battery-pack",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_mini-battery-pack",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_team-danger-boost",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      },
      {
        actionId: "item_full-revive",
        instanceId: makeId("itemInstance", 10),
        isStolen: false
      }
    ],
    computerAiPersonality: {
      default: {
        regular: 2,
        vicious: 2,
        recovering: 6,
        cursing: 3,
        cleaning: 2,
        boosting: 6,
        thief: 2
      }
    }
  }
];

export function getLoadout(id: string) {
  return sampleLoadouts.find(loadout => loadout.loadoutId === id);
}

/** Return one of the sample loadouts */
export function getRandomLoadout() {
  const combatantData = randomFromArray(sampleLoadouts);

  return {
    ...combatantData,

    ...randomFromArray(skinAndNameCombos),
    //Adding this property here because it seems more in line with building your character.
    //Team object will be built from `wantsToJoinTeam` properties (when master sends out `isBattleInit`)
    wantsToJoinTeam: randomFromArray(["one", "two"])
  };
}



// WEBPACK FOOTER //
// ./src/Fixture_combatants.js